import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { takeUntil } from 'rxjs/operators';
import { SearchService } from '../core/search.service';
import { CommonService } from '../../../shared/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '../../projects/core/projects.service';
import * as $ from 'jquery';

@Component({
    selector: 'app-search-wrapper',
    templateUrl: './search-wrapper.component.html',
    styleUrls: ['./search-wrapper.component.scss'],
    animations: [
        trigger('rightAnimation', [
            state('*', style({
                width: '0px',
            })),
            state('sidenavOpen', style({
                width: '535px',
            })),
            state('sidenavClosed', style({
                width: '0px',
            })),
            transition('*=>sidenavOpen', animate('500ms')),
            transition('* => void, * => sidenavClosed', animate('500ms')),
        ]),
        trigger('legendAnimation', [
            state('visible', style({
                transform: 'translate(0%, 0%) scale(1)',
                opacity: 1,
            })),
            state('void, hidden', style({
                transform: 'translate(-30%, 25%) scale(0.4)',
                opacity: 0,
            })),
            transition('* => visible', animate('250ms')),
            transition('* => void, * => hidden', animate('250ms')),
        ]),
    ],
    standalone: false
})
export class SearchWrapperComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef }) container: any;
  showSidenav = false;
  isFullScreen = false;

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private searchService: SearchService,
    private projectsService: ProjectsService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit() {
    this.searchService.openRightPanel
      .pipe(takeUntil(this.onDestroy))
      .subscribe(params => {
        this.showSidenav = true;
        setTimeout(() => {
          this.createComponent(params?.component, params?.data);
        }, 300);
      });

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        this.isFullScreen = 'fs' in qp;
      });

    this.searchService.closeRightPanel
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.close();
      });

    this.commonService.closeSearchPopup.next(true);
  }

  ngAfterViewInit() {
    $('app-search-wrapper .wrapper .left').scroll(() => {
      if ($('app-search-wrapper .wrapper .left').scrollTop() > 200) {
        this.commonService.setHeaderBgWhite.next(true);
      } else {
        this.commonService.setHeaderBgWhite.next(false);
      }
    });
  }

  createComponent(component, data) {
    this.container?.clear();

    const componentRef = this.container?.createComponent(component);
    componentRef.instance.data = data;
  }

  close() {
    this.projectsService.isAnyFormDirty.next(false);
    this.router.navigate([], {
      queryParams: {
        selectedId: null,
      },
      queryParamsHandling: 'merge',
    }).then(() => {
      this.showSidenav = false;
      this.container?.clear();
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
